import React from 'react';
import styles from './Tabs.module.scss';

const Tabs = ({ tabs, activeTab, onChange, rightAction }) => {
  return (
    <div className={styles.tabsWrapper}>
      <div className={styles.tabs}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`${styles.tab} ${
              activeTab === tab.key ? styles.active : ''
            }`}
            onClick={() => onChange(tab.key)}
          >
            <p>{tab.label}</p>
            {tab.icon && <p className={styles.icon}>{tab.icon}</p>}
          </button>
        ))}
      </div>

      {/* {rightAction && <div className={styles.rightAction}>{rightAction}</div>} */}
    </div>
  );
};

export default Tabs;
